import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { useLocalizedActivityData } from '../data/localizedData';

interface RelatedActivitiesProps {
  activityIds: string[];
  title?: string;
}

export const RelatedActivities: React.FC<RelatedActivitiesProps> = ({ activityIds, title }) => {
  const { t } = useLanguage();

  if (!activityIds || activityIds.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-semibold mb-6">
        {title || t('common.relatedActivities')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {activityIds.map((activityId) => {
          const activityData = useLocalizedActivityData(activityId);
          if (!activityData) return null;

          return (
            <Link
              key={activityId}
              to={`/activities/${activityId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <div className="bg-gray-50 rounded-lg p-5 hover:bg-gray-100 transition-colors duration-200">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-32 h-32 rounded-lg overflow-hidden">
                    <img
                      src={`/activities/${activityId}/${activityId}_homepage.webp`}
                      alt={activityData.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = '/images/default-activity.jpg';
                      }}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-lg font-semibold text-gray-900 group-hover:text-orange-600 transition-colors duration-200">
                      {activityData.name}
                    </h4>
                    <p className="text-sm text-gray-600 mt-1">
                      {activityData.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}; 